import { create } from 'zustand';

interface PlanApprovalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * Global open/close flag for the single day-15 platform-trial approval dialog
 * (`ApprovePlanModal`, PRD V6.0 ①/③). Owned by the layout
 * (`PlatformTrialController` mounts the one dialog instance) — any other
 * surface that needs to show it (the permanent read-only bar, the
 * credit-exhaustion flow once `awaitingApproval`) just calls `open()` rather
 * than rendering its own copy of the dialog.
 */
export const usePlanApprovalStore = create<PlanApprovalState>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
